import React, { useState, useEffect } from 'react';
import './ReadingMomentum.css';

const MOMENTS = [
  { at: 5,  text: "You've started — great" },
  { at: 20, text: 'Getting interesting...' },
  { at: 40, text: "You're in the flow" },
  { at: 60, text: "Keep going — it gets better" },
  { at: 75, text: 'Almost there 🔥' },
  { at: 90, text: 'Final stretch — finish strong' },
  { at: 99, text: 'You read it all ✨' },
];

const CIRCUMFERENCE = 2 * Math.PI * 15.9;

export default function ReadingMomentum() {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const el    = document.documentElement;
      const total = Math.max(1, el.scrollHeight - window.innerHeight);
      setPct(Math.min(100, Math.round((window.scrollY / total) * 100)));
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (pct < 5) return null;

  const msg  = [...MOMENTS].reverse().find(m => pct >= m.at)?.text || '';
  const dash = (pct / 100) * CIRCUMFERENCE;

  return (
    <div className="rm-wrap" aria-hidden="true">
      {msg && <span className="rm-msg">{msg}</span>}
      <div className="rm-ring">
        <svg viewBox="0 0 36 36" fill="none">
          <circle cx="18" cy="18" r="15.9" stroke="rgba(166,124,97,0.18)" strokeWidth="3.2" />
          <circle
            cx="18" cy="18" r="15.9"
            stroke="#A67C61" strokeWidth="3.2"
            strokeDasharray={`${dash} ${CIRCUMFERENCE - dash}`}
            strokeLinecap="round"
            style={{ transform: 'rotate(-90deg)', transformOrigin: '18px 18px', transition: 'stroke-dasharray 0.4s ease' }}
          />
        </svg>
        <span className="rm-pct">{pct}%</span>
      </div>
    </div>
  );
}
